'use strict';

var intellidealerAppPartsModule = angular.module('intellidealerApp.parts',
                                                 ['intellidealerApp.core']);

